module.exports = __webpack_public_path__ + "static/media/amplify.0c40b1c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/amplify.svg
// module id = 3367
// module chunks = 6